<template>
    <!-- Layout component -->
    <component :is="currentLayout" v-if="isRouterLoaded">
        <router-view></router-view>
    </component>
</template>

<script>
    import { importComponents } from '~/helpers'

    export default {
        components: {
            ...importComponents(require.context('components/layouts')),
        },

        computed: {
            isRouterLoaded: function () {
                return this.$route.name !== null
            },
            currentLayout: function () {
                let layout = this.$route.meta.layout || 'default'

                if (this.$auth.isSubdomainActive()) {
                    layout = 'subdomain'
                }

                document.title = this.getMetaTitle()
                document.head.querySelector('meta[property="og:title"]').content = this.getMetaTitle()
                document.head.querySelector('meta[property="og:description"]').content = this.getMetaDescription()

                return `${layout}-layout`
            },
        },
        methods: {
            getMetaTitle() {
                return this.$route.meta.title || 'Bookeraj - Rezerviši i pruži usluge online'
            },
            getMetaDescription() {
                return (
                    this.$route.meta.description ||
                    'Naše online mesto vam omogućava da lako rezervišete različite usluge ili ponudite svoje usluge drugima. Pronađite i rezervišite ono što vam treba.'
                )
            },
        },

        watch: {
            $route: {
                handler: function () {
                    window.scrollTo(0, 0)
                },
            },
        },

        mounted() {
            const url = window.location.href
            const urlComponents = url.split('//')
            const protocol = urlComponents[0]
            const remainingUrl = urlComponents[1]

            if (remainingUrl.startsWith('www.')) {
                const modifiedUrl = protocol + '//' + remainingUrl.replace('www.', '')
                window.location.href = modifiedUrl
            }
            if (window.location.href.includes('/%23/')) {
                window.location.href = window.location.href.replace(/\/%23\//g, '/#/')
            }
        },
    }
</script>
